import { useMemo } from "react";
import { useLocation } from "react-router";
import { findNavItem } from "@/config/nav";

export type Crumb = { title: string; link: string };

// Adapted from connect-v2: usePathname (Next) → useLocation; titles come from the nav config.
export function useBreadcrumbs(): Crumb[] {
	const { pathname } = useLocation();
	return useMemo(() => {
		const segments = pathname.split("/").filter(Boolean);
		return segments.map((segment, i) => {
			const link = `/${segments.slice(0, i + 1).join("/")}`;
			const item = findNavItem(link);
			const title =
				item?.url === link ? item.title : segment.charAt(0).toUpperCase() + segment.slice(1);
			return { title, link };
		});
	}, [pathname]);
}
